module.exports = __webpack_public_path__ + "static/satiating.1bf30413.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/satiating.svg
// module id = 385
// module chunks = 73016943110679